import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../components/card/card";
import ImageViewer from "../../components/ImageViewer";
import {
  formatDateTime,
  generateLocationToArray,
  printDate,
  printLocation,
} from "../../utils/helper";
import React, { useState, useEffect } from "react";
import { notification, userRole } from "../../api";
import { parserAPI } from "../../utils/parser";
import { formatDateFull } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { startOfDay, endOfDay, format } from "date-fns";

function NotificationLogs() {
  const [userRoles, setUserRoles] = useState([]);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [location_wording, setLocation_wording] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { config } = useAuth();
  const navigate = useNavigate();

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  async function getDatas() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await notification.listNotifThreshold(queryParam);
      const datas = await parserAPI(res);
      datas.results.forEach((d) => {
        const locationNameArr = [];
        generateLocationToArray(d.machine_detail.location, locationNameArr);
        d.location_arr = locationNameArr.reverse();
      });

      setData(datas.results);
      if (datas.totalData) {
        setQuery((prev) => ({
          ...prev,
          totalData: datas.totalData,
        }));
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getDatas();
    // eslint-disable-next-line
  }, [query.page, query.take]);
  async function deleteUserRoleConfirm(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  async function deleteUserRole() {
    try {
      const response = await userRole.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          toast.success("This role has been deleted");
          setConfirmDlg(false);
          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }

        getDatas();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function addUserRole(value) {
    setOpenDetail(true);
  }
  function editUserRole(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  const columns = [
    {
      name: "Date",
      width: "200px",
      selector: (row) => formatDateTime(row.created_at),
    },
    {
      name: "Machine",
      width: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>{row.description.split("|")[0]}</span>;
      },
    },
    ...generateLocationWording().map((w, i) => ({
      name: w,

      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Alert",

      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <span className="text-capitalize">
            {row.notif_type.replaceAll("_", " ")}
          </span>
        );
      },
    },
  ];

  const handleRowClick = (row) => {
    const created_at = row.created_at;
    const start = format(
      startOfDay(new Date(created_at)),
      "yyyy-MM-dd HH:mm:ss"
    );
    const end = format(endOfDay(new Date(created_at)), "yyyy-MM-dd HH:mm:ss");
    const machine_element = row.description.split("|")[3];
    const feature_name = row.description.split("|")[4];
    const feature_value = row.description.split("|")[5];
    const notif_type = row.notif_type;
    navigate(
      `/sensor/live/${row.machine_detail.id}?start=${start}&end=${end}&machine_element=${machine_element}&feature_name=${feature_name}&feature_value=${feature_value}&notif_type=${notif_type}`
    );
  };
  async function onSubmit({ name, userRoleFeatureAccess, accesses, status }) {
    let data = {
      rolename: name,
      accesses,
      feature_accesses: userRoleFeatureAccess.map((fa) => ({
        page_name: fa.name,
        ...fa,
        name: undefined,
      })),
      //is_active: status == "1" ? true : false,
    };

    if (!selectedRow) {
      const response = await userRole.create(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await userRole.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("Role " + name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
    getDatas();
  }

  return (
    <div>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUserRole}
      >
        <div>Are you sure you want to delete this role?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Notification</a>
            </li>
          </ol>
          <h1 className="page-header mb-0">Notification Logs</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <Card className="mb-4 mt-2">
            <CardBody>
              <DataTable
                onRowClicked={handleRowClick}
                pointerOnHover
                highlightOnHover
                theme="dark"
                columns={columns}
                data={data}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
                progressPending={loading}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default NotificationLogs;

